import { createSelector } from 'reselect';

const selector = (state, id) => {
  id = parseInt(id);
  return state.projects.items.filter(i => i.id === id).asMutable({ deep: true });
}

export default createSelector(
  [selector], result => result.length ? result[0] : null
)



// WEBPACK FOOTER //
// ./src/selectors/project-selector.js